import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

import { currentUserReducer } from '®shared/current-user/current-user.reducer';
import { tenantReducer } from '®shared/tenant/tenant.reducer';

import { State } from './state';

export const reducers: ActionReducerMap<State> = {
  currentUser: currentUserReducer,
  router: routerReducer,
  tenancy: tenantReducer,
};
